<!--
  @component PerformanceScreen — combined cache + queue tab.
  tier:      screen (per-project — `/projects/:id/performance`)
  mounts:    CacheIO + QueueIO   (effecting portals for o-arc + p-arc)
-->
<script lang="ts">
  import CacheIO from "../../../../global/io/nodes/deployment/CacheIO.svelte";
  import QueueIO from "../../../../global/io/nodes/deployment/QueueIO.svelte";
  import PerformancePanel from "./PerformancePanel.svelte";
</script>

<CacheIO>
  {#snippet children()}
    <QueueIO>
      {#snippet children()}
        <PerformancePanel />
      {/snippet}
    </QueueIO>
  {/snippet}
</CacheIO>
